
import { Button, Modal, } from "react-bootstrap"
import { toast } from "react-toastify"
import { forwardRef, useImperativeHandle, useState } from "react"
import i18next from 'i18next';
import { FileUploader } from "react-drag-drop-files"
import SpinnerButton from "../SpinnerButton/SpinnerButton";

const SUPPORTED_FILE_TYPES = [
  'pdf',
  'doc',
  'docx',
  'ppt',
  'pptx',
]

type Props = {
  show: boolean
  onHide: any
  labels?: { title: string, body: string, confirmBtn: string }
  onSuccess: () => void
  maxSize?: number;
  handleReporterDocument: (file?: File | null) => void;
}

const defaultLabels = {
  title: i18next.t('upload_document'),
  body: '',
  confirmBtn: i18next.t('confirm'),
}

export type ReporterDocumentationFileHandle = {
  clear: () => void;
};

const ReporterDocumentationFileUploader = forwardRef<ReporterDocumentationFileHandle, Props>(({
  show,
  onHide,
  handleReporterDocument,
  labels = defaultLabels,
  onSuccess,
  maxSize
}, ref) => {
  const [uploadFile, setUploadFile] = useState<File | null>(null)
  const [uploadError, setUploadError] = useState<string | null>(null);

  const onModalHide = () => {
    setUploadFile(null)
    onHide()
  };

  useImperativeHandle(ref, () => ({
    clear: () => {
      setUploadError(null);
      setUploadFile(null);
    }
  }));

  return (
    <Modal show={show} onHide={onModalHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{labels.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {labels.body}
          <div>
            <FileUploader
              fileOrFiles={uploadFile}
              classes="dropzone"
              types={SUPPORTED_FILE_TYPES}
              handleChange={(file) => {
                if (typeof maxSize !== 'undefined' && file?.size > maxSize) {
                  toast.error(`Dimensione di caricamento massima superata (max ${maxSize / 1024 / 1024} MB)`);
                  return
                }
                setUploadFile(file);
              }}
              onTypeError={() => {
                setUploadFile(null);
                setUploadError(i18next.t('unsupported_file'));
              }}
              name="file"
            >
              <div className="text-center">
                <div className="fs-4">
                  <div>{i18next.t('click_or_drag_file')}</div>
                </div>
                <div>
                  <small>({SUPPORTED_FILE_TYPES.join(', ')})</small>
                </div>
              </div>

              <div className="text-center">
                {uploadFile && uploadFile?.size > 0 ? (
                  <ul className="mt-3">
                    <li key="name"> {uploadFile?.name} </li>
                  </ul>
                ) : (
                  ''
                )}
                {uploadError
                  ? <p className="mt-4 text-danger">{uploadError}</p>
                  : null
                }
              </div>
            </FileUploader>
            {uploadFile && uploadFile?.size > 0 ? (
              <div className="d-flex justify-content-end text-right">
                <Button
                  variant="danger"
                  onClick={() => {
                    setUploadFile(null);
                    handleReporterDocument(null);
                  }}
                  className="my-3 btn btn-sm btn-outline file-uploader-clear-btn"
                  type="button"
                >
                  {i18next.t('delete')}
                </Button>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => {
          handleReporterDocument(uploadFile);
          onSuccess?.()
        }}>
          <SpinnerButton label={labels.confirmBtn} busy={false} />
        </Button>
      </Modal.Footer>
    </Modal>
  )
})

export default ReporterDocumentationFileUploader;

